var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.profileMode)?[_vm._t("extra"),_vm._v(" "),_c('nuxt-link',{attrs:{"to":`${_vm.route}/${_vm.param}`,"tag":_vm.tag}},[_vm._t("default")],2)]:[_c('a',{attrs:{"href":_setup.hrefLink,"target":"_blank","rel":"nofollow noopener noreferrer"}},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }